import { Injectable, VERSION } from "@angular/core";
import { HttpHeaders, HttpParams } from "@angular/common/http";
import { Auth } from "../auth";
import { HttpRequestOptions } from "../../domain/http-request-options";

@Injectable()
export class DefaultRequestOptions extends HttpRequestOptions {
  headers: HttpHeaders = new HttpHeaders();
  constructor(auth?: Auth) {
    super();
    if (auth) {
      this.headers = new HttpHeaders();
      const token = auth.token.tokenType + " " + auth.token.token;
      this.headers = this.headers
        .set("Content-Type", "application/json")
        .append("Authorization", token)
        .append("X-Evr-Client-Url", window.location.href)
        .append("X-Evr-Client-Application", "Angular")
        .append("X-Evr-Client-Version", VERSION.full);
    }
  }
}
